import React from 'react';
import PropTypes from 'prop-types';

/**
 * Draw Simulator sidebar module - simulate drawing hands
 */
function DrawSimulator({
  isCollapsed,
  onToggle,
  drawnCards,
  remainingDeck,
  hasDrawn,
  mulliganCount,
  deckHasCards,
  onDrawInitialHand,
  onMulligan,
  onResetDraw,
  getProxyImageUrl,
}) {
  return (
    <div className="sidebar-section draw-simulator-section">
      <div className="section-header">
        <h4>🎲 Draw Simulator</h4>
        <button 
          className="collapse-btn" 
          onClick={onToggle}
          title={isCollapsed ? "Expand" : "Collapse"}
        >
          {isCollapsed ? '▶' : '▼'}
        </button>
      </div>

      {!isCollapsed && (
        <>
          {!deckHasCards ? (
            <p className="no-cards-message">Add cards to your deck to use the draw simulator</p>
          ) : (
            <>
              {!hasDrawn ? (
                <button className="draw-btn" onClick={onDrawInitialHand}>
                  Draw Opening Hand
                </button>
              ) : (
                <>
                  <div className="drawn-cards-container">
                    <h5>Hand ({drawnCards.length})</h5>
                    <div className="drawn-cards">
                      {drawnCards.map((card, index) => (
                        <div key={index} className="drawn-card-item">
                          <img
                            src={getProxyImageUrl(card.images?.blob?.thumbnail || card.images?.original?.thumbnail)}
                            alt={card.name}
                            className="drawn-card-image"
                            title={card.name}
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="draw-actions">
                    <button 
                      className="mulligan-btn" 
                      onClick={onMulligan}
                      disabled={mulliganCount >= 1 || remainingDeck.length < 6}
                    >
                      Mulligan {mulliganCount > 0 && '(Used)'}
                    </button>
                    <button className="reset-draw-btn" onClick={onResetDraw}>
                      New Hand
                    </button>
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
}

DrawSimulator.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  drawnCards: PropTypes.array.isRequired,
  remainingDeck: PropTypes.array.isRequired,
  hasDrawn: PropTypes.bool.isRequired,
  mulliganCount: PropTypes.number.isRequired,
  deckHasCards: PropTypes.bool.isRequired,
  onDrawInitialHand: PropTypes.func.isRequired,
  onMulligan: PropTypes.func.isRequired,
  onResetDraw: PropTypes.func.isRequired,
  getProxyImageUrl: PropTypes.func.isRequired,
};

export default DrawSimulator;
